<template>
  <div>
    <van-nav-bar
      title="扫码记录"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      fixed
    />
    <div class="psiConfirmCont">
      <div class="psiDetailCont">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            finished-text="没有更多了"
          >
            <div v-for="item in list" class="card" :key="item.uuid">
              <template>
                <table class="layout">
                  <tr>
                    <td><span>商品编码：</span>{{ item.skuCode }}</td>
                  </tr>
                  <tr>
                    <td><span>商品名称：</span>{{ item.skuIdname }}</td>
                  </tr>
                  <tr>
                    <td><span>商品条码：</span>{{ item.barcode }}</td>
                  </tr>
                  <tr>
                    <td><span>货位：</span>{{ item.binIdname }}</td>
                  </tr>
                  <tr>
                    <td><span>扫码时间：</span>{{ item.operationTime }}</td>
                  </tr>
                  <tr>
                    <td><span>操作人：</span>{{ item.advisorIdname }}</td>
                  </tr>
                </table>
              </template>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Field, Button, List, PullRefresh, Toast } from "vant";
import electronicInputService from "../../service/electronicInputService";
import { formatDictionary } from "../../utils/dictionary";
import moment from "moment";

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      fields:[],
      dictNames: "",
      showPosition: true
    };
  },
  mounted: async function() {

    let that = this;
    document.onkeydown = function(event) {
      if (event.keyCode == 13) {
        that.tempPosition = that.position;
        that.tempValue = that.value;
        if(that.tempPosition.length > 0){
          if(that.tempPosition.indexOf("HW") < 0 && that.positionId.indexOf("HW") < 0){
            that.value = that.tempPosition;
            this.position = "";
          }
        }
        if(that.tempValue.length > 0){
          if(that.tempValue.indexOf("HW") > -1){
            that.position = that.tempValue;
            that.value = "";
          }
        }
        if ((that.position.length > 0 && that.value.length == 0)
              || (!that.showPosition && that.value.length == 0)) {
          that.$refs.barcodeInput.focus();
        } else {
          that.confirm();
        }
      }
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async confirm() {
      let resp = await electronicInputService.inputForMobile(this.value, this.position);
      if (resp.data.Status === "1") {
        this.barcodeIds.push(resp.data.Data);
        Toast.success("扫码入库成功");
        this.value = "";
        this.$refs.barcodeInput.focus();
        this.quantity++;
        this.onRefresh();
      } else {
        /*if(this.showPosition){
          top.location.href = "/audio/alert";
        }*/
        Toast.fail(resp.data.Message);
        this.value = "";
        if (this.position.length == 0 && this.showPosition) {
          this.$refs.positionInput.focus();
        } else {
          this.$refs.barcodeInput.focus();
        }

      }
    },
    async onLoad() {
      this.pageIndex++;
      let resp = await electronicInputService.getInputDetailForMobile(
        this.pageIndex,
          this.$route.params.inputDataId,
          "",
          "input"
      );
      if (resp.data.Status == '1' && resp.data.Data.data.length > 0) {
        resp.data.Data.data.forEach(item => {
          item.operationTime = moment(item.operationTime).format("YYYY-MM-DD HH:mm:ss");
        });
        formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
        this.list = [...this.list, ...resp.data.Data.data];
      }else{
        this.list = [];
      }
      this.loading = false;
      this.refreshing = false;
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    }
  },
  watch: {
    async position() {
      let resp = await electronicInputService.getPositionById(this.position);
      if (resp.data.Status === "1") {
        this.position = resp.data.Data.name;
        this.positionId = resp.data.Data.uuid;
      }
    }
  }
};
</script>

<style scoped>
.psiConfirmCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 120px;
  overflow: hidden;
}
.btnBox {
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom: 0;
  position: fixed;
  width: 100%;
}
.psiDetailCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
}
</style>
